import React, { useContext, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Container, Form, Button } from "semantic-ui-react";
import {
  combineValidators,
  composeValidators,
  isRequired,
  hasLengthGreaterThan,
  hasLengthLessThan,
  matchesPattern,
  isNumeric
} from "revalidate";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { ISellerForm } from "../../../app/models/seller";
import TextInput from "../../../app/common/form/TextInput";

const validate = combineValidators({
  fullName: composeValidators(
    isRequired({ message: "El Nombre es obligatorio" }),
    matchesPattern(/^[a-zA-Z0-9\ ]*$/)({
      message: "Solo se permiten caracteres alfanumérico",
    }),
    hasLengthLessThan(81)({
      message: "El Nombre debe tener máximo 80 caracteres",
    })
  )(),
  phone: composeValidators(
    isRequired({ message: "El Teléfono es obligatorio" }),
    matchesPattern(/^[a-zA-Z0-9\.()-\\]*$/)({
      message:
        "Teléfono no válido. Contiene espacios o caracteres especiales diferente a: ( ) - . \\",
    }),
    hasLengthGreaterThan(6)({
      message: "El Teléfono debe tener al menos 7 caracteres",
    }),
    hasLengthLessThan(33)({
      message: "El Teléfono debe tener máximo 32 caracteres",
    })
  )(),
  identification: composeValidators(
    isRequired({ message: "La identificación es obligatoria" }),
    isNumeric({ message: "a identificación debe ser numerica" }),
    hasLengthGreaterThan(4)({
      message: "La identificación debe tener al menos 5 caracteres",
    }),
    hasLengthLessThan(13)({
      message: "La identificación debe tener máximo 12 caracteres",
    })
  )(),
  email: composeValidators(
    isRequired({ message: "El Email es obligatorio" }),
    matchesPattern(/^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/)({
      message: "Por favor digite un Email valido",
    }),
    hasLengthLessThan(257)({
      message: "El Email debe tener máximo 256 caracteres",
    }),
    hasLengthGreaterThan(5)({
      message: "El Email debe tener al menos 6 caracteres",
    }),
  )(),
});

interface IProps {
  seller: ISellerForm;
}

const EditSellerForm: React.FC<IProps> = ({ seller }) => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { editSeller } = rootStore.sellerStore;
  const { loading } = rootStore.buttonLoadingStore;

  const [newSellerForm] = useState<ISellerForm>({
    id: seller.id,
    fullName: seller.fullName,
    identification: seller.identification,
    phone: seller.phone,
    email: seller.email,
  });

  const handleFinalFormSubmit = (values: any) => {
    values.fullName = values.fullName.trim();
    values.email = values.email.trim();
    values.phone = values.phone.trim();
    editSeller(values);
  };

  return (
    <div className="modalContent">
      <FinalForm
        validate={validate}
        initialValues={newSellerForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">
              <label>Nombre</label>
              <Field
                name="fullName"
                value={newSellerForm.fullName}
                component={TextInput}
              />
              <label>Identificación</label>
              <Field
                name="identification"
                value={newSellerForm.identification}
                component={TextInput}
              />
              <label>Teléfono</label>
              <Field
                name="phone"
                value={newSellerForm.phone}
                component={TextInput}
              />
              <label>Mail notificaciones</label>
              <Field
                name="email"
                value={newSellerForm.email}
                component={TextInput}
              />
              <br />
              <br />
              <Button
                loading={loading}
                disabled={loading}
                className="ui primary button"
                color="blue"
                type="submit"
                content="Guardar"
              />
            </Container>
          </Form>
        )}
      />
    </div>
  );
};

export default observer(EditSellerForm);
